var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundCheckWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FCEBC1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 16C5.25 10.0858 10.0858 5.25 16 5.25C21.9142 5.25 26.75 10.0858 26.75 16C26.75 21.9142 21.9142 26.75 16 26.75C10.0858 26.75 5.25 21.9142 5.25 16ZM16 6.75C10.9142 6.75 6.75 10.9142 6.75 16C6.75 21.0858 10.9142 25.25 16 25.25C21.0858 25.25 25.25 21.0858 25.25 16C25.25 10.9142 21.0858 6.75 16 6.75Z",
    fill: "#E38100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7808 12.6402C21.0734 12.9333 21.073 13.4082 20.7799 13.7008L15.1099 19.3608C14.8169 19.6533 14.3424 19.6531 14.0497 19.3604L11.2197 16.5304C10.9268 16.2375 10.9268 15.7626 11.2197 15.4697C11.5126 15.1768 11.9874 15.1768 12.2803 15.4697L14.5805 17.7699L19.7201 12.6392C20.0133 12.3466 20.4882 12.347 20.7808 12.6402Z",
    fill: "#E38100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCheckWithBg);
export default __webpack_public_path__ + "static/media/round-check-with-bg.ef0c464546fe4f00cbddcc61adec79e4.svg";
export { ForwardRef as ReactComponent };